import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nickname'
})
export class NicknamePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return value;
    } else {
      return 'Anonymous';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/nickname.pipe.ts